import(/* webpackMode: "eager" */ "/var/www/html/cliquefatos-headless/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/html/cliquefatos-headless/src/app/Components/Home/columnists.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/cliquefatos-headless/src/app/Components/Others/client-push-notification-card.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/cliquefatos-headless/src/app/Components/ScriptsClient/add-script-client.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/cliquefatos-headless/src/app/Components/ScriptsClient/html-from-wp.js");
